import { get, isNil } from "lodash";

const getters = {
  getCurrentCVCode: (state) => {
    if (!isNil(state.stepperStatus.Wizard)) {
      return get(state.stepperStatus.Wizard, "CVCode", null);
    }
    return 0;
  },
  getStepsperStatus: (state) => {
    return state.stepperStatus.Stepper;
  },

  getCVWStepContent: (state) => (stepNum) => {
    return state.content[stepNum];
  },

  isRegisteredSmartAlerts: (state) => {
    return state.userStatus.isRegisteredSmartAlerts;
  },
  getUserCvFiles: (state) => {
    return state.userStatus.cvFiles;
  },

  getCVWStepData: (state) => (stepNum) => {
    const stepNumber = parseInt(stepNum);
    if (
      state.initializedCVW &&
      !_.isEmpty(state.stepperStatus) &&
      !_.isEmpty(state.stepperStatus.Wizard) &&
      stepNumber >= 1 &&
      stepNumber <= 5
    ) {
      return state.stepperStatus.Wizard["Step" + stepNumber];
    }

    return null;
  },

  isStepAvailable: (state) => (stepNum) => {
    try {
      const stepNumber = parseInt(stepNum);
      if (
        state.initializedCVW &&
        !_.isEmpty(state.stepperStatus) &&
        stepNumber >= 1 &&
        stepNumber <= 5
      ) {
        return state.stepperStatus.Stepper[stepNumber - 1].IsAvailable;
      }
    } catch (error) {
      console.log(error);
    }
  },

};

export default getters;
